import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import AdvForm from '../../../CommonComponents/AdvForm';
import Footer from '../../Footer/FooterContainer';
import {
  simpleSelectDefaultValue,
  simpleSelectChangedToNonNull,
} from '../../../Profile/Accounts_react/AccountsUtils';
import PlanImpact from '../../PlanImpact/PlanImpactContainer';
import Loading from '../../Loading/LoadingView';
import { isNumeric, isUuid, createCustomPropType } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';

class LifeExpectanciesView extends Component {
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;
    fetchData(clientId, fpId, goalId);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(previousProps) {
    const { clientId, fpId, goalId, whatIf, fetchPlanImpact, whatIfTemplate } = this.props;

    const impactTriggerProps = ['whatIf', 'fpId', 'isOPLMonteCarlo'];

    if (!isEqual(pick(this.props, impactTriggerProps), pick(previousProps, impactTriggerProps))) {
      fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
    }
  }

  render() {
    const {
      goalId,
      clientId,
      principalName,
      partnerName,
      hasPartner,
      principalOptions,
      partnerOptions,
      storeData,
      loading,
      planImpactItems,
      title,
      groupTitle,
      fpId,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      principalLifeExpectancy,
      partnerLifeExpectancy,
      areOptionsLoaded,
    } = this.props;
    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <AdvForm>
            <ValidationErrors clientId={clientId} />
            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>
              <li className="what-ifs-form-field">
                <div className="what-ifs-age-label">
                  <Select
                    isPortal
                    label={principalName}
                    id="PrincipalLifeExpectancy"
                    value={simpleSelectDefaultValue(principalOptions, principalLifeExpectancy)}
                    onChange={simpleSelectChangedToNonNull(
                      clientId,
                      storeData(goalId),
                      'WhatIf.LifeExpectancyPrincipal',
                    )}
                    options={principalOptions}
                  />
                </div>
              </li>
              {hasPartner && (
                <li className="what-ifs-form-field">
                  <div className="what-ifs-age-label">
                    <Select
                      isPortal
                      label={partnerName}
                      id="PartnerLifeExpectancy"
                      value={simpleSelectDefaultValue(partnerOptions, partnerLifeExpectancy)}
                      onChange={simpleSelectChangedToNonNull(
                        clientId,
                        storeData(goalId),
                        'WhatIf.LifeExpectancySpouse',
                      )}
                      options={partnerOptions}
                    />
                  </div>
                </li>
              )}
            </ul>
          </AdvForm>
        </div>
        <PlanImpact clientId={clientId} planImpactItems={planImpactItems} />
        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}
LifeExpectanciesView.defaultProps = {
  title: 'Untitled What If',
  groupTitle: 'Untitled What If Group',
  partnerName: '',
  principalName: '',
  partnerOptions: [],
  principalLifeExpectancy: 0,
  partnerLifeExpectancy: 0,
};

LifeExpectanciesView.propTypes = {
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  principalName: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  hasPartner: PropTypes.bool.isRequired,
  partnerName: PropTypes.string,
  principalOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  partnerOptions: PropTypes.arrayOf(PropTypes.shape({})),
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  principalLifeExpectancy: createCustomPropType(isNumeric),
  partnerLifeExpectancy: createCustomPropType(isNumeric),
  storeData: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  planImpactItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      current: PropTypes.string.isRequired,
      proposed: PropTypes.string.isRequired,
    }),
  ).isRequired,
  applyWhatIf: PropTypes.func.isRequired,
};

export default LifeExpectanciesView;
